import React, { Component } from 'react'
import loadable from '@loadable/component'
import getVideoDetailInitialProps from '../public/getVideoDetailInitialProps'

const VideoDetail = loadable(() => import('../containers/VideoDetail'))

export default class VideoListPage extends Component {
    static async getInitialProps (context) {
        return getVideoDetailInitialProps(context)
    }

    render () {
        return <VideoDetail {...this.props} />
    }
}
